// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a321ddc4","453":"42f33040","667":"42045c60"}[chunkId] + ".chunk.js";
};